export default __webpack_public_path__ + "static/media/interaction11.d5b98218.png";